import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import nombreAlojamiento from "../../../img/onboarding/nombra_alojamiento.jpg";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import { useDispatchDominio } from "../../../hooks/useDispatchDominio";
import { fetchAxiosToken } from "../../../helpers/fetchAxiosToken";
import { ButtonRegresar } from "../../../components/ButtonRegresar";
import { ButtonSiguiente } from "../../onboardingHotel/ButtonSiguiente";

interface TipoHabitacion {
    id: number;
    id_casa: number;
    nombre: string;
}

export const NombreHabitacionHotel = () => {
    const { id: id_casa, plan } = useAppSelector(
        (state) => state.landing_house.house
    );
    const [tipos, setTipos] = useState<TipoHabitacion[]>([]);
    const [loadingTipos, setLoadingTipos] = useState(false);
    const [selectedTipoId, setSelectedTipoId] = useState<number | "">("");
    const { idCasa } = useParams();

    const [input, setInput] = useState({
        nombre: "",
        descripcion: "",
    });

    const navigate = useNavigate();

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInput({
            ...input,
            [e.target.name]: e.target.value,
        });
    };

    const getOneHabitacion = async () => {
        fetchAxiosToken({
            url: `/hotel_habitaciones/detalle/${idCasa}`,
        })
            .then((res) => {
                console.log(res);
                setInput(res);
                setSelectedTipoId(res.id_tipo_hotel_habitaciones);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const getTiposHabitacion = async () => {
        if (!id_casa) return;
        setLoadingTipos(true);
        try {
            const res = await fetchAxiosToken({
                url: `/tipo_hotel_habitaciones/getAll/${id_casa}`,
                method: "get",
            });
            const data = (res?.data || res?.payload || res) as TipoHabitacion[];
            setTipos(Array.isArray(data) ? data : []);
        } catch (err) {
            console.log(err);
            setTipos([]);
        } finally {
            setLoadingTipos(false);
        }
    };

    useEffect(() => {
        if (idCasa && Number(idCasa) > 0) getOneHabitacion();
    }, []);

    useEffect(() => {
        getTiposHabitacion();
    }, [id_casa]);

    const handleSubmit = async () => {
        if (!input.nombre) {
            return Swal.fire({
                title: "Debes escoger un nombre válido",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }

        if (!input.descripcion)
            return Swal.fire({
                title: "Debes agregar una descripción",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        if (!selectedTipoId) {
            return Swal.fire({
                title: "Debes seleccionar un tipo de habitación",
                icon: "warning",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
            });
        }
        try {
            if (idCasa && Number(idCasa) > 0) {
                await fetchAxiosToken({
                    url: `/hotel_habitaciones/updateNombre/${idCasa}`,
                    method: "put",
                    body: {
                        nombre: input.nombre,
                        descripcion: input.descripcion,
                        id_tipo_hotel_habitaciones: Number(selectedTipoId),
                    },
                });

                console.log("habitacion actualizada");

                navigate(
                    `/dashboard-hotel/onboarding/capacidad-habitacion/${idCasa}`
                );
            } else {
                const data = await fetchAxiosToken({
                    url: `/hotel_habitaciones`,
                    method: "post",
                    body: {
                        id_hotel: id_casa,
                        nombre: input.nombre,
                        descripcion: input.descripcion,
                        id_tipo_hotel_habitaciones: Number(selectedTipoId),
                    },
                });

                console.log("habitacion creada", data);

                navigate(
                    `/dashboard-hotel/onboarding/capacidad-habitacion/${data.data.id}`
                );
            }
        } catch (error) {
            console.log(error);
        }
    };
    const crearNuevoTipo = async () => {
        const { value: nombre } = await Swal.fire({
            title: "Nuevo tipo de habitación",
            input: "text",
            inputLabel: "Nombre del tipo",
            inputPlaceholder: "ej. Suite Deluxe",
            confirmButtonText: "Crear",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#029BFC",
            inputValidator: (value) => {
                if (!value || !value.trim()) {
                    return "Debes ingresar un nombre válido";
                }
                if (
                    tipos.some(
                        (t) =>
                            t.nombre.toLowerCase().trim() ===
                            value.toLowerCase().trim()
                    )
                ) {
                    return "Ese tipo ya existe";
                }
                return null;
            },
        });

        if (!nombre) return;

        try {
            const res = await fetchAxiosToken({
                url: `/tipo_hotel_habitaciones`,
                method: "post",
                body: {
                    nombre: nombre.trim(),
                },
            });

            const success = res?.data?.success ?? res?.success ?? true;
            const message = res?.data?.message ?? res?.message ?? "";
            const payload = res?.data?.data ?? res?.data ?? res?.payload;

            if (
                success === false &&
                typeof message === "string" &&
                message.toLowerCase().includes("ya existe")
            ) {
                const existenteLocal =
                    tipos.find(
                        (t) =>
                            t.nombre.toLowerCase().trim() ===
                            nombre.toLowerCase().trim()
                    ) || null;

                if (existenteLocal) {
                    setSelectedTipoId(existenteLocal.id);
                } else {
                    await getTiposHabitacion();
                    const existenteRecargado = tipos.find(
                        (t) =>
                            t.nombre.toLowerCase().trim() ===
                            nombre.toLowerCase().trim()
                    );
                    if (existenteRecargado)
                        setSelectedTipoId(existenteRecargado.id);
                }

                await Swal.fire({
                    icon: "warning",
                    title: "El tipo ya existe",
                    text: "Seleccioné el existente.",
                    confirmButtonColor: "#029BFC",
                });
                return;
            }

            const creado = payload as TipoHabitacion | undefined;

            if (creado?.id) {
                const nuevos = [...tipos, creado].sort((a, b) =>
                    a.nombre.localeCompare(b.nombre)
                );
                setTipos(nuevos);
                setSelectedTipoId(creado.id);

                Swal.fire({
                    icon: "success",
                    title: "Tipo creado",
                    timer: 1200,
                    showConfirmButton: false,
                });
            } else {
                await getTiposHabitacion();
                const recienCreado = tipos.find(
                    (t) =>
                        t.nombre.toLowerCase().trim() ===
                        nombre.toLowerCase().trim()
                );
                if (recienCreado) setSelectedTipoId(recienCreado.id);

                Swal.fire({
                    icon: "success",
                    title: "Tipo creado",
                    timer: 1200,
                    showConfirmButton: false,
                });
            }
        } catch (error: any) {
            console.log(error);
            Swal.fire({
                icon: "error",
                title: "No se pudo crear el tipo",
                text:
                    error?.response?.data?.message ||
                    error?.message ||
                    "Intenta nuevamente",
            });
        }
    };
    return (
        <div className="flex flex-col h-screen grid-cols-2 lg:grid">
            <div className="block h-56 md:h-1/3 lg:h-auto bg-black/80">
                <div className="relative flex flex-col items-center justify-center h-full text-center lg:h-screen">
                    <img
                        src={nombreAlojamiento}
                        alt="nombreAlojamiento"
                        className="w-full h-full"
                    />
                    <div className="absolute top-0 w-full h-full bg-black opacity-40 "></div>
                    <div className="absolute top-0 flex flex-col items-center justify-center w-2/3 h-full 0">
                        <div className="text-2xl font-bold text-center text-white md:text-4xl 2xl:text-6xl ">
                            Escoge un nombre para tu habitación
                        </div>

                        <div className="mt-5 text-lg text-center text-white md:text-xl 2xl:text-2xl md:mt-14 ">
                            ¡No te preocupes podrás cambiarlo más adelante!
                        </div>
                    </div>
                </div>
            </div>
            <div className="relative flex flex-col justify-center h-screen p-3 text-center text-black bg-white">
                <ButtonRegresar
                    url={`${"/dashboard-hotel/habitaciones"}`}
                    className="absolute top-10 left-10"
                    arrowColor="black"
                    textColor="black"
                />
                <div className="flex flex-col items-start justify-center w-3/4 mx-auto md:w-2/3 lg:w-1/2">
                    <h2 className="mt-3 text-xl font-medium md:text2xl lg:text-3xl">
                        Tipo de habitación
                    </h2>
                    <div className="flex items-center w-full gap-2 mt-2">
                        <select
                            className="w-10/12 p-3 text-black border border-gray-500 rounded-lg"
                            value={selectedTipoId}
                            onChange={(e) =>
                                setSelectedTipoId(
                                    e.target.value ? Number(e.target.value) : ""
                                )
                            }
                            disabled={loadingTipos}>
                            <option value="">
                                {loadingTipos
                                    ? "Cargando tipos..."
                                    : "Selecciona un tipo"}
                            </option>
                            {tipos
                                .slice()
                                .sort((a, b) =>
                                    a.nombre.localeCompare(b.nombre)
                                )
                                .map((t) => (
                                    <option key={t.id} value={t.id}>
                                        {t.nombre}
                                    </option>
                                ))}
                        </select>

                        <button
                            type="button"
                            onClick={crearNuevoTipo}
                            className="flex items-center h-full gap-2 px-3 py-2 text-sm font-semibold border border-gray-500 rounded-lg hover:bg-gray-50"
                            disabled={loadingTipos}
                            title="Crear nuevo tipo">
                            <p>+</p> Nuevo
                        </button>
                    </div>
                    <h2 className="text-xl font-medium md:text2xl lg:text-3xl">
                        Nombre
                    </h2>
                    <input
                        type={"text"}
                        name="nombre"
                        value={input.nombre}
                        onChange={handleInputChange}
                        placeholder="ej. Habitación Duple Superior"
                        className="w-full p-3 mt-2 text-black border border-gray-500 rounded-lg placeholder:italic"
                    />

                    <h2 className="mt-3 text-xl font-medium md:text2xl lg:text-3xl">
                        Descripción
                    </h2>
                    <div className="w-full p-2 mt-2 text-black border border-gray-500 rounded-lg">
                        <textarea
                            onChange={(e) =>
                                setInput({
                                    ...input,
                                    descripcion: e.target.value,
                                })
                            }
                            value={input.descripcion}
                            placeholder="ej. Cuenta con dos camas de 1 plaza y baño"
                            className="w-full h-20 text-sm bg-transparent border-none outline-none focus:outline-none 2xl:text-base placeholder:text-gray-400 placeholder:italic"
                        />
                    </div>

                    <ButtonSiguiente onSubmit={() => handleSubmit()} />
                </div>
            </div>
        </div>
    );
};
